import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { Box } from '@mui/material';
import { ROLES } from '../../utils/appRoles';
import axios, { unAuthAxios } from '../../utils/axios';
import FormGroup from '../shared/containers/FormGroup';
import Input from '../shared/formInput/Input';
import SelectInput from '../shared/formInput/SelectInput';
import PrimaryButton from '../shared/buttons/PrimaryButton';
import { useEffect, useState } from 'react';
import { handleExcludedFields } from '../../utils/form';
import SwitchInput from '../shared/formInput/SwitchInput';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const UpdateUserPasswordForm = ({submitButtonChildren='envoyer', dataUrl}) => {
    const {logout} = useAuth();
    const navigate = useNavigate();
    
    const [initialValues, setInitialValues] = useState(null)
    const [linkError, setLinkError] = useState("")
    const formValues = {
        email: '',
        password: '',
    };



    useEffect(() => {
        (async () => {
            try {
                const response = await unAuthAxios.get(`user/new_password/${dataUrl.uidb64}/${dataUrl.id}`);
                const email = response?.data?.user_email
                setInitialValues({email});
            } catch (error) {
                const message = error.response?.data?.message;
                if (message) {
                    setLinkError({message: message});
                    return;
                }
                navigate('/', {replace: true});
            }

        })()
    }, []);
    
    const onSubmit = async (values, {resetForm, setErrors, setSubmitting, setDirty}) => {
        try {
            const password = values?.password
            await unAuthAxios.patch(`user/new_password/${dataUrl.uidb64}/${dataUrl.id}/`, {password});
            logout();
            navigate('/', {replace: true});
            // keep the values after submission and dirty to false
            resetForm({values}) 
        } catch (error) {
            setErrors({createError: error.message})
            // console.error(error)
        }
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .required("champ requis")
            .email("format: utilisateur@domaine.fr"),
        password: Yup.string()
            .required("champ requis")
            .trim("Sans d'espace")
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/, { message: "Le mot de passe doit à minima contenir 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.", excludeEmptyString: true })
            .strict(),
        password_confirm: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Mot de passe différent')
    });

    const formStyle = {
        border: "1px solid", // TODO: put in theme
        borderColor: "primary.main",
        borderRadius: "4px",
        width: "fit-content",
        padding: "2em",
        maxWidth: "307.36px"
    };

    return (
        linkError.message ?
        <Box sx={formStyle}>
            <p>{linkError.message}</p>
        </Box> :
        (initialValues &&
        <Formik {...{ initialValues, onSubmit, validationSchema, enableReinitialize:true }}>
            {({errors, isValid, dirty}) => (
                <Box sx={formStyle}>
                    {errors.createError && <p>{errors.createError}</p>}
                    <Form autoComplete="off">
                        
                        <FormGroup>
                            <Input
                                InputProps={{
                                    readOnly: true,
                                }}
                                {...{
                                    name: "email",
                                    label: "Email",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "password",
                                    label: "Mot de passe",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "password_confirm",
                                    label: "Confirmation mot de passe",
                                }}
                            />
                        </FormGroup>
                        
                        
                        <PrimaryButton type="submit" disabled={!isValid || !dirty}>
                            {submitButtonChildren}
                        </PrimaryButton>
                    </Form>
                </Box>
            )}
        </Formik>)
    );
}



export default UpdateUserPasswordForm;